
// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Paper,
//   Typography,
//   CircularProgress,
//   Stepper,
//   Step,
//   StepLabel,
//   Box,
//   Chip,
//   Divider,
//   List,
//   ListItem,
//   ListItemText,
//   Grid,
//   Card,
//   CardContent,
//   Avatar,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import {
//   CheckCircle,
//   Cancel,
//   HourglassEmpty,
//   Star,
//   Leaderboard,
//   Groups,
//   EventAvailable,
// } from '@mui/icons-material';

// const StatusChip = styled(Chip)(({ theme, status }) => ({
//   fontWeight: 'bold',
//   backgroundColor:
//     status === 'In Progress'
//       ? theme.palette.warning.main
//       : status === 'Completed'
//       ? theme.palette.success.main
//       : status === 'Not Started'
//       ? theme.palette.error.main
//       : theme.palette.info.main,
//   color: theme.palette.common.white,
// }));

// const ScoreChip = styled(Chip)(({ theme }) => ({
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
//   fontWeight: 'bold',
//   padding: theme.spacing(1),
//   fontSize: '1rem',
// }));

// const StudentTrack = () => {
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProjectData = async () => {
//       try {
//         const response = await fetch(
//           'https://puneexpobackend.tdtlworld.com/api/project_info/?stud_id=9'
//         );
//         if (!response.ok) {
//           throw new Error('Failed to fetch project data.');
//         }
//         const data = await response.json();

//         const transformedData = {
//           projectName: data.data[0].idea_submissions.title,
//           status:
//             data.data[0].idea_submissions.status === 'submitted'
//               ? 'In Progress'
//               : 'Not Started',
//           description: data.data[0].idea_submissions.description,
//           currentStage: 1,
//           stages: [
//             {
//               name: 'Idea Submission',
//               status:
//                 data.data[0].idea_submissions.status === 'submitted'
//                   ? 'Completed'
//                   : 'Not Started',
//             },
//             { name: 'Review', status: 'Not Started' },
//             { name: 'Development', status: 'Not Started' },
//           ],
//           teamSize: 1,
//           teamMembers: [
//             { name: 'Student', role: 'Single Participant' },
//           ],
//           mentorFeedback: 'Feedback not available',
//           upcomingDeadline: 'N/A',
//           investorInterest: 'N/A',
//           projectScore: 85,
//           additionalScores: [
//             { name: 'Innovation Score', value: 78 },
//             { name: 'Presentation Score', value: 92 },
//           ],
//         };

//         setProjectData(transformedData);
//       } catch (err) {
//         setError(err.message || 'An unexpected error occurred.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjectData();
//   }, []);

//   if (loading) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error: {error}
//         </Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ mt: 4, mb: 4, marginTop: '100px' }}>
//       <Paper elevation={3} sx={{ p: 3 }}>
//         <Typography
//           variant="h4"
//           gutterBottom
//           sx={{ color: 'primary.main', fontWeight: 'bold', textAlign: 'center' }}
//         >
//           🚀 Project Tracking: {projectData.projectName}
//         </Typography>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             mb: 2,
//           }}
//         >
//           <Typography variant="h6">{projectData.description}</Typography>
//           <StatusChip label={projectData.status} status={projectData.status} />
//         </Box>

//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             my: 3,
//           }}
//         >
//           <ScoreChip
//             icon={<Star fontSize="large" />}
//             label={`Overall Score: ${projectData.projectScore}/100`}
//           />
//         </Box>

//         <Divider sx={{ my: 3 }} />

//         <Typography
//           variant="h5"
//           gutterBottom
//           sx={{ color: 'secondary.main', fontWeight: 'bold' }}
//         >
//           Project Tracking
//         </Typography>
//         <Stepper activeStep={projectData.currentStage} alternativeLabel>
//           {projectData.stages.map((stage, index) => (
//             <Step key={stage.name}>
//               <StepLabel
//                 StepIconComponent={() => {
//                   if (stage.status === 'Completed') return <CheckCircle color="success" />;
//                   if (stage.status === 'In Progress') return <HourglassEmpty color="warning" />;
//                   return <Cancel color="error" />;
//                 }}
//               >
//                 {stage.name}
//               </StepLabel>
//             </Step>
//           ))}
//         </Stepper>

//         <Divider sx={{ my: 3 }} />

//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom>
//                   Team Information
//                 </Typography>
//                 <Typography variant="body1" gutterBottom>
//                   Team Size: {projectData.teamSize}
//                 </Typography>
//                 <List dense>
//                   {projectData.teamMembers.map((member, index) => (
//                     <ListItem key={index}>
//                       <Avatar sx={{ bgcolor: 'secondary.main', mr: 2 }}>
//                         {member.name[0]}
//                       </Avatar>
//                       <ListItemText
//                         primary={member.name}
//                         secondary={member.role}
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               </CardContent>
//             </Card>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom>
//                   Project Metrics
//                 </Typography>
//                 <List dense>
//                   <ListItem>
//                     <ListItemText
//                       primary="Current Stage"
//                       secondary={projectData.stages[projectData.currentStage].name}
//                     />
//                   </ListItem>
//                   <ListItem>
//                     <ListItemText
//                       primary="Upcoming Deadline"
//                       secondary={projectData.upcomingDeadline}
//                     />
//                   </ListItem>
//                   <ListItem>
//                     <ListItemText
//                       primary="Investor Interest"
//                       secondary={projectData.investorInterest}
//                     />
//                   </ListItem>
//                 </List>
//               </CardContent>
//             </Card>
//           </Grid>
//           <Grid item xs={12}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom>
//                   Additional Scores
//                 </Typography>
//                 <Grid container spacing={2}>
//                   {projectData.additionalScores.map((score, index) => (
//                     <Grid item key={index} xs={12} md={6}>
//                       <Card sx={{ textAlign: 'center', bgcolor: 'primary.light', p: 2 }}>
//                         <Leaderboard fontSize="large" sx={{ mb: 1, color: 'primary.dark' }} />
//                         <Typography variant="h6" gutterBottom>
//                           {score.name}
//                         </Typography>
//                         <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
//                           {score.value}/100
//                         </Typography>
//                       </Card>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>

//         <Box sx={{ mt: 3 }}>
//           <Typography
//             variant="h6"
//             gutterBottom
//             sx={{ color: 'text.secondary' }}
//           >
//             Mentor Feedback
//           </Typography>
//           <Typography variant="body1">{projectData.mentorFeedback}</Typography>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default StudentTrack;

// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Paper,
//   Typography,
//   CircularProgress,
//   Stepper,
//   Step,
//   StepLabel,
//   Box,
//   Chip,
//   Divider,
//   List,
//   ListItem,
//   ListItemText,
//   Grid,
//   Card,
//   CardContent,
//   Avatar,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import {
//   CheckCircle,
//   Cancel,
//   HourglassEmpty,
//   Star,
//   Leaderboard,
// } from '@mui/icons-material';

// const StatusChip = styled(Chip)(({ theme, status }) => ({
//   fontWeight: 'bold',
//   backgroundColor:
//     status === 'In Progress'
//       ? theme.palette.warning.main
//       : status === 'Completed'
//       ? theme.palette.success.main
//       : status === 'Not Started'
//       ? theme.palette.error.main
//       : theme.palette.info.main,
//   color: theme.palette.common.white,
// }));

// const ScoreChip = styled(Chip)(({ theme }) => ({
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
//   fontWeight: 'bold',
//   padding: theme.spacing(1),
//   fontSize: '1rem',
// }));

// const StudentTrack = () => {
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProjectData = async () => {
//       try {
//         const response = await fetch(
//           'https://puneexpobackend.tdtlworld.com/api/project_info/?stud_id=9'
//         );
//         if (!response.ok) {
//           throw new Error('Failed to fetch project data.');
//         }
//         const data = await response.json();

//         const transformedData = {
//           projectName: data.data[0].idea_submissions.title,
//           status:
//             data.data[0].idea_submissions.status === 'submitted'
//               ? 'In Progress'
//               : 'Not Started',
//           description: data.data[0].idea_submissions.description,
//           currentStage: 1,
//           stages: [
//             {
//               name: 'Idea Submission',
//               status:
//                 data.data[0].idea_submissions.status === 'submitted'
//                   ? 'Completed'
//                   : 'Not Started',
//             },
//             { name: 'Review', status: 'Not Started' },
//             { name: 'Development', status: 'Not Started' },
//           ],
//           teamSize: 1,
//           teamMembers: [
//             { name: 'Student', role: 'Single Participant' },
//           ],
//           mentorFeedback: 'Feedback not available',
//           upcomingDeadline: 'N/A',
//           investorInterest: 'N/A',
//           projectScore: 85,
//           additionalScores: [
//             { name: 'Innovation Score', value: 78 },
//             { name: 'Presentation Score', value: 92 },
//           ],
//         };

//         setProjectData(transformedData);
//       } catch (err) {
//         setError(err.message || 'An unexpected error occurred.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjectData();
//   }, []);

//   if (loading) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error: {error}
//         </Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ mt: 4, mb: 4, marginTop: '100px' }}>
//       <Paper elevation={3} sx={{ p: 3 }}>
//         <Typography
//           variant="h4"
//           gutterBottom
//           sx={{ color: 'primary.main', fontWeight: 'bold', textAlign: 'center' }}
//         >
//           🚀 Project Tracking: {projectData.projectName}
//         </Typography>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             mb: 2,
//           }}
//         >
//           <Typography variant="h6">{projectData.description}</Typography>
//           <StatusChip label={projectData.status} status={projectData.status} />
//         </Box>

//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             my: 3,
//           }}
//         >
//           <ScoreChip
//             icon={<Star fontSize="large" />}
//             label={`Overall Score: ${projectData.projectScore}/100`}
//           />
//         </Box>

//         <Divider sx={{ my: 3 }} />

//         <Typography
//           variant="h5"
//           gutterBottom
//           sx={{ color: 'secondary.main', fontWeight: 'bold' }}
//         >
//           Project Tracking
//         </Typography>
//         <Stepper activeStep={projectData.currentStage} alternativeLabel>
//           {projectData.stages.map((stage, index) => (
//             <Step key={stage.name}>
//               <StepLabel
//                 StepIconComponent={() => {
//                   if (stage.status === 'Completed') return <CheckCircle color="success" />;
//                   if (stage.status === 'In Progress') return <HourglassEmpty color="warning" />;
//                   return <Cancel color="error" />;
//                 }}
//               >
//                 {stage.name}
//               </StepLabel>
//             </Step>
//           ))}
//         </Stepper>

//         <Divider sx={{ my: 3 }} />

//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom>
//                   Team Information
//                 </Typography>
//                 <Typography variant="body1" gutterBottom>
//                   Team Size: {projectData.teamSize}
//                 </Typography>
//                 <List dense>
//                   {projectData.teamMembers.map((member, index) => (
//                     <ListItem key={index}>
//                       <Avatar sx={{ bgcolor: 'secondary.main', mr: 2 }}>
//                         {member.name[0]}
//                       </Avatar>
//                       <ListItemText
//                         primary={member.name}
//                         secondary={member.role}
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               </CardContent>
//             </Card>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom>
//                   Project Metrics
//                 </Typography>
//                 <List dense>
//                   <ListItem>
//                     <ListItemText
//                       primary="Current Stage"
//                       secondary={projectData.stages[projectData.currentStage].name}
//                     />
//                   </ListItem>
//                   <ListItem>
//                     <ListItemText
//                       primary="Upcoming Deadline"
//                       secondary={projectData.upcomingDeadline}
//                     />
//                   </ListItem>
//                   <ListItem>
//                     <ListItemText
//                       primary="Investor Interest"
//                       secondary={projectData.investorInterest}
//                     />
//                   </ListItem>
//                 </List>
//               </CardContent>
//             </Card>
//           </Grid>
//           <Grid item xs={12}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom sx={{ textAlign: 'center', fontWeight: 'bold', color: 'primary.main' }}>
//                   Additional Scores
//                 </Typography>
//                 <Grid container spacing={3} justifyContent="center">
//                   {projectData.additionalScores.map((score, index) => (
//                     <Grid item key={index} xs={12} md={6}>
//                       <Card
//                         sx={{
//                           textAlign: 'center',
//                           bgcolor: 'secondary.light',
//                           color: 'secondary.contrastText',
//                           p: 2,
//                           borderRadius: 2,
//                           boxShadow: 3,
//                         }}
//                       >
//                         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
//                           <Leaderboard fontSize="large" sx={{ color: 'secondary.dark' }} />
//                         </Box>
//                         <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
//                           {score.name}
//                         </Typography>
//                         <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
//                           {score.value}/100
//                         </Typography>
//                       </Card>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>

//         <Box sx={{ mt: 3 }}>
//           <Typography
//             variant="h6"
//             gutterBottom
//             sx={{ color: 'text.secondary' }}
//           >
//             Mentor Feedback
//           </Typography>
//           <Typography variant="body1">{projectData.mentorFeedback}</Typography>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default StudentTrack;

// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Paper,
//   Typography,
//   CircularProgress,
//   Box,
//   Chip,
//   Divider,
//   Grid,
//   Card,
//   CardContent,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { Star, CheckCircle, Cancel, HourglassEmpty } from '@mui/icons-material';

// const StatusChip = styled(Chip)(({ theme, status }) => ({
//   fontWeight: 'bold',
//   backgroundColor:
//     status === 'In Progress'
//       ? theme.palette.warning.main
//       : status === 'Completed'
//       ? theme.palette.success.main
//       : status === 'Not Started'
//       ? theme.palette.error.main
//       : theme.palette.info.main,
//   color: theme.palette.common.white,
// }));

// const ScoreChip = styled(Chip)(({ theme }) => ({
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
//   fontWeight: 'bold',
//   padding: theme.spacing(1),
//   fontSize: '1rem',
// }));

// const StudentTrack = () => {
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProjectData = async () => {
//       try {
//         const userId = localStorage.getItem('user_id');
//         const response = await fetch(
//           `https://puneexpobackend.tdtlworld.com/api/project_info/?stud_id=${userId}`
//         );
//         if (!response.ok) {
//           throw new Error('Failed to fetch project data.');
//         }
//         const data = await response.json();

//         const transformedData = {
//           projectName: data.data[0].idea_submissions.title,
//           status:
//             data.data[0].idea_submissions.status === 'submitted'
//               ? 'In Progress'
//               : 'Not Started',
//           description: data.data[0].idea_submissions.description,
//           projectScore: 85,
//           mentorFeedback: 'Feedback not available',
//         };

//         setProjectData(transformedData);
//       } catch (err) {
//         setError(err.message || 'An unexpected error occurred.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjectData();
//   }, []);

//   if (loading) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error: {error}
//         </Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ mt: 4, mb: 4, marginTop: '50px' }}>
//       <Grid container spacing={3}>
//         {/* Project Name and Description Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//               🌐 Project Overview
//             </Typography>
//             <Typography variant="h6" sx={{ mb: 1 }}>
//               {projectData.projectName}
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.description}
//             </Typography>
//           </Card>
//         </Grid>

//         {/* Project Status Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3, textAlign: 'center' }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//               🔄 Project Status
//             </Typography>
//             <StatusChip
//               label={projectData.status}
//               status={projectData.status}
//               sx={{ fontSize: '1rem', p: 1 }}
//             />
//           </Card>
//         </Grid>

//         {/* Project Score Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3, textAlign: 'center' }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//               ⭐ Project Score
//             </Typography>
//             <ScoreChip
//               icon={<Star fontSize="large" />}
//               label={`Overall Score: ${projectData.projectScore}/100`}
//             />
//           </Card>
//         </Grid>

//         {/* Mentor Feedback Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//               🧠 Mentor Feedback
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.mentorFeedback}
//             </Typography>
//           </Card>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default StudentTrack;

// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Paper,
//   Typography,
//   CircularProgress,
//   Box,
//   Chip,
//   Divider,
//   Grid,
//   Card,
//   CardContent,
//   Stepper,
//   Step,
//   StepLabel,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { Star, CheckCircle, Cancel, HourglassEmpty } from '@mui/icons-material';

// const StatusChip = styled(Chip)(({ theme, status }) => ({
//   fontWeight: 'bold',
//   backgroundColor:
//     status === 'In Progress'
//       ? theme.palette.warning.main
//       : status === 'Completed'
//       ? theme.palette.success.main
//       : status === 'Not Started'
//       ? theme.palette.error.main
//       : theme.palette.info.main,
//   color: theme.palette.common.white,
// }));

// const ScoreChip = styled(Chip)(({ theme }) => ({
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
//   fontWeight: 'bold',
//   padding: theme.spacing(1),
//   fontSize: '1rem',
// }));

// const StudentTrack = () => {
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProjectData = async () => {
//       try {
//         const userId = localStorage.getItem('user_id');
//         const response = await fetch(
//           `https://puneexpobackend.tdtlworld.com/api/project_info/?stud_id=${userId}`
//         );
//         if (!response.ok) {
//           throw new Error('Failed to fetch project data.');
//         }
//         const data = await response.json();

//         const transformedData = {
//           projectName: data.data[0].idea_submissions.title,
//           status:
//             data.data[0].idea_submissions.status === 'submitted'
//               ? 'In Progress'
//               : 'Not Started',
//           description: data.data[0].idea_submissions.description,
//           projectScore: 85,
//           mentorFeedback: 'Feedback not available',
//           currentStage: 1,
//           stages: [
//             {
//               name: 'Idea Submission',
//               status: 'Completed',
//             },
//             {
//               name: 'Review',
//               status: 'In Progress',
//             },
//             {
//               name: 'Development',
//               status: 'Not Started',
//             },
//           ],
//         };

//         setProjectData(transformedData);
//       } catch (err) {
//         setError(err.message || 'An unexpected error occurred.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjectData();
//   }, []);

//   if (loading) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error: {error}
//         </Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ mt: 4, mb: 4, marginTop: '50px' }}>
//       <Grid container spacing={3}>
//         {/* Project Name and Description Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//               🌐 Project Overview
//             </Typography>
//             <Typography variant="h6" sx={{ mb: 1 }}>
//               {projectData.projectName}
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.description}
//             </Typography>
//           </Card>
//         </Grid>

//         {/* Project Tracking Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3 }}>
//             <Typography
//               variant="h5"
//               gutterBottom
//               sx={{ color: 'secondary.main', fontWeight: 'bold' }}
//             >
//               Project Tracking
//             </Typography>
//             <Stepper activeStep={projectData?.currentStage || 0} alternativeLabel>
//   {projectData?.stages?.map((stage, index) => (
//     <Step key={stage.name}>
//       <StepLabel
//         StepIconComponent={() => {
//           if (stage.status === 'Completed') return <CheckCircle color="success" />;
//           if (stage.status === 'In Progress') return <HourglassEmpty color="warning" />;
//           return <Cancel color="error" />;
//         }}
//       >
//         {stage.name}
//       </StepLabel>
//     </Step>
//   ))}
// </Stepper>

//           </Card>
//         </Grid>

//         {/* Project Score Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3, textAlign: 'center' }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//               ⭐ Project Score
//             </Typography>
//             <ScoreChip
//               icon={<Star fontSize="large" />}
//               label={`Overall Score: ${projectData.projectScore}/100`}
//             />
//           </Card>
//         </Grid>

//         {/* Mentor Feedback Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//               🧠 Mentor Feedback
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.mentorFeedback}
//             </Typography>
//           </Card>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default StudentTrack;

// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Paper,
//   Typography,
//   CircularProgress,
//   Box,
//   Chip,
//   Divider,
//   Grid,
//   Card,
//   CardContent,
//   Stepper,
//   Step,
//   StepLabel,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { Star, CheckCircle, Cancel, HourglassEmpty } from '@mui/icons-material';

// const StatusChip = styled(Chip)(({ theme, status }) => ({
//   fontWeight: 'bold',
//   backgroundColor:
//     status === 'In Progress'
//       ? theme.palette.warning.main
//       : status === 'Completed'
//       ? theme.palette.success.main
//       : status === 'Not Started'
//       ? theme.palette.error.main
//       : theme.palette.info.main,
//   color: theme.palette.common.white,
// }));

// const ScoreChip = styled(Chip)(({ theme }) => ({
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
//   fontWeight: 'bold',
//   padding: theme.spacing(1),
//   fontSize: '1rem',
// }));

// const StudentTrack = () => {
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const userEmail = localStorage.getItem('userEmail');
//   const userId = localStorage.getItem('user_id');

//   useEffect(() => {
//     const fetchProjectData = async () => {
//       try {
//         const response = await fetch(
//           `https://puneexpobackend.tdtlworld.com/api/project_info/?stud_id=${userId}`
//         );
//         if (!response.ok) {
//           throw new Error('Failed to fetch project data.');
//         }
//         const data = await response.json();

//         const transformedData = {
//           projectName: data.data[0].idea_submissions.title,
//           status:
//             data.data[0].idea_submissions.status === 'submitted'
//               ? 'In Progress'
//               : 'Not Started',
//           description: data.data[0].idea_submissions.description,
//           projectScore: 85,
//           mentorFeedback: 'Feedback not available',
//           currentStage: 1,
//           stages: [
//             {
//               name: 'Idea Submission',
//               status: 'Completed',
//             },
//             {
//               name: 'Review',
//               status: 'In Progress',
//             },
//             {
//               name: 'Development',
//               status: 'Not Started',
//             },
//           ],
//         };

//         setProjectData(transformedData);
//       } catch (err) {
//         setError(err.message || 'An unexpected error occurred.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjectData();
//   }, [userId]);

//   if (loading) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error: {error}
//         </Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ mt: 4, mb: 4, marginTop: '50px' }}>
//       {/* Profile Info Card */}
//       <Box mb={3}>
//         <Card elevation={3} sx={{ p: 3, textAlign: 'center' }}>
//           <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
//             👤 Profile Information
//           </Typography>
//           <Typography variant="body1" sx={{ fontSize: '1.2rem' }}>
//             Email: {userEmail || 'Not Available'}
//           </Typography>
//           <Typography variant="body1" sx={{ fontSize: '1.2rem' }}>
//             User ID: {userId}
//           </Typography>
//         </Card>
//       </Box>

//       <Grid container spacing={3}>
//         {/* Project Name and Description Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//               🌐 Project Overview
//             </Typography>
//             <Typography variant="h6" sx={{ mb: 1 }}>
//               {projectData.projectName}
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.description}
//             </Typography>
//           </Card>
//         </Grid>

//         {/* Project Tracking Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3 }}>
//             <Typography
//               variant="h5"
//               gutterBottom
//               sx={{ color: 'secondary.main', fontWeight: 'bold' }}
//             >
//               Project Tracking
//             </Typography>
//             <Stepper activeStep={projectData?.currentStage || 0} alternativeLabel>
//               {projectData?.stages?.map((stage, index) => (
//                 <Step key={stage.name}>
//                   <StepLabel
//                     StepIconComponent={() => {
//                       if (stage.status === 'Completed') return <CheckCircle color="success" />;
//                       if (stage.status === 'In Progress') return <HourglassEmpty color="warning" />;
//                       return <Cancel color="error" />;
//                     }}
//                   >
//                     {stage.name}
//                   </StepLabel>
//                 </Step>
//               ))}
//             </Stepper>
//           </Card>
//         </Grid>

//         {/* Project Score Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3, textAlign: 'center' }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//               ⭐ Project Score
//             </Typography>
//             <ScoreChip
//               icon={<Star fontSize="large" />}
//               label={`Overall Score: ${projectData.projectScore}/100`}
//             />
//           </Card>
//         </Grid>

//         {/* Mentor Feedback Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//               🧠 Mentor Feedback
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.mentorFeedback}
//             </Typography>
//           </Card>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default StudentTrack;

// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Paper,
//   Typography,
//   CircularProgress,
//   Box,
//   Chip,
//   Divider,
//   Grid,
//   Card,
//   CardContent,
//   Stepper,
//   Step,
//   StepLabel,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { Star, CheckCircle, Cancel, HourglassEmpty } from '@mui/icons-material';

// const StatusChip = styled(Chip)(({ theme, status }) => ({
//   fontWeight: 'bold',
//   backgroundColor:
//     status === 'In Progress'
//       ? theme.palette.warning.main
//       : status === 'Completed'
//       ? theme.palette.success.main
//       : status === 'Not Started'
//       ? theme.palette.error.main
//       : theme.palette.info.main,
//   color: theme.palette.common.white,
// }));

// const ScoreChip = styled(Chip)(({ theme }) => ({
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
//   fontWeight: 'bold',
//   padding: theme.spacing(1),
//   fontSize: '1rem',
// }));

// const StudentTrack = () => {
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const userEmail = localStorage.getItem('userEmail');
//   const userId = localStorage.getItem('user_id');

//   useEffect(() => {
//     const fetchProjectData = async () => {
//       try {
//         const response = await fetch(
//           `https://puneexpobackend.tdtlworld.com/api/project_info/?stud_id=${userId}`
//         );
//         if (!response.ok) {
//           throw new Error('Failed to fetch project data.');
//         }
//         const data = await response.json();

//         const transformedData = {
//           projectName: data.data[0].idea_submissions.title,
//           status:
//             data.data[0].idea_submissions.status === 'submitted'
//               ? 'In Progress'
//               : 'Not Started',
//           description: data.data[0].idea_submissions.description,
//           projectScore: 85,
//           mentorFeedback: 'Feedback not available',
//           currentStage: 1,
//           stages: [
//             {
//               name: 'Idea Submission',
//               status: 'Completed',
//             },
//             {
//               name: 'Review',
//               status: 'In Progress',
//             },
//             {
//               name: 'Development',
//               status: 'Not Started',
//             },
//           ],
//         };

//         setProjectData(transformedData);
//       } catch (err) {
//         setError(err.message || 'An unexpected error occurred.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjectData();
//   }, [userId]);

//   if (loading) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error: {error}
//         </Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ mt: 4, mb: 4, marginTop: '80px' }}>
//       {/* Profile Info Card */}
//       <Box mb={3}>
//         <Card elevation={3} sx={{ p: 4, textAlign: 'center', backgroundColor: '#f0f8ff', borderRadius: 3 }}>
//           <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: '#6a1b9a' }}>
//             👤 Profile Information
//           </Typography>
//           <Typography variant="body1" sx={{ fontSize: '1.2rem', mb: 1 }}>
//             Email: {userEmail || 'Not Available'}
//           </Typography>
//           <Typography variant="body1" sx={{ fontSize: '1.2rem' }}>
//             User ID: {userId}
//           </Typography>
//         </Card>
//       </Box>

//       <Grid container spacing={4}>
//         {/* Project Name and Description Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, backgroundColor: '#e8f5e9', borderRadius: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#1b5e20' }}>
//               🌐 Project Overview
//             </Typography>
//             <Typography variant="h6" sx={{ mb: 1, color: '#2e7d32' }}>
//               {projectData.projectName}
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.description}
//             </Typography>
//           </Card>
//         </Grid>

//         {/* Project Tracking Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, backgroundColor: '#f3e5f5', borderRadius: 3 }}>
//             <Typography
//               variant="h5"
//               gutterBottom
//               sx={{ color: '#4a148c', fontWeight: 'bold' }}
//             >
//               Project Tracking
//             </Typography>
//             <Stepper activeStep={projectData?.currentStage || 0} alternativeLabel>
//               {projectData?.stages?.map((stage, index) => (
//                 <Step key={stage.name}>
//                   <StepLabel
//                     StepIconComponent={() => {
//                       if (stage.status === 'Completed') return <CheckCircle color="success" />;
//                       if (stage.status === 'In Progress') return <HourglassEmpty color="warning" />;
//                       return <Cancel color="error" />;
//                     }}
//                   >
//                     {stage.name}
//                   </StepLabel>
//                 </Step>
//               ))}
//             </Stepper>
//           </Card>
//         </Grid>

//         {/* Project Score Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, textAlign: 'center', backgroundColor: '#e3f2fd', borderRadius: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#1565c0' }}>
//               ⭐ Project Score
//             </Typography>
//             <ScoreChip
//               icon={<Star fontSize="large" />}
//               label={`Overall Score: ${projectData.projectScore}/100`}
//             />
//           </Card>
//         </Grid>

//         {/* Mentor Feedback Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, backgroundColor: '#ffebee', borderRadius: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#b71c1c' }}>
//               🧠 Mentor Feedback
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.mentorFeedback}
//             </Typography>
//           </Card>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default StudentTrack;
// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Paper,
//   Typography,
//   CircularProgress,
//   Box,
//   Chip,
//   Divider,
//   Grid,
//   Card,
//   CardContent,
//   Stepper,
//   Step,
//   StepLabel,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { Star, CheckCircle, Cancel, HourglassEmpty } from '@mui/icons-material';

// const StatusChip = styled(Chip)(({ theme, status }) => ({
//   fontWeight: 'bold',
//   backgroundColor:
//     status === 'In Progress'
//       ? theme.palette.warning.main
//       : status === 'Completed'
//       ? theme.palette.success.main
//       : status === 'Not Started'
//       ? theme.palette.error.main
//       : theme.palette.info.main,
//   color: theme.palette.common.white,
// }));

// const ScoreChip = styled(Chip)(({ theme }) => ({
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
//   fontWeight: 'bold',
//   padding: theme.spacing(1),
//   fontSize: '1rem',
// }));

// const StudentTrack = () => {
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const userEmail = localStorage.getItem('userEmail');
//   const userId = localStorage.getItem('user_id');

//   useEffect(() => {
//     const fetchProjectData = async () => {
//       try {
//         const response = await fetch(
//           `https://puneexpobackend.tdtlworld.com/api/project_info/?stud_id=${userId}`
//         );
//         if (!response.ok) {
//           throw new Error('Failed to fetch project data.');
//         }
//         const data = await response.json();

//         const transformedData = {
//           projectName: data.data[0].idea_submissions.title,
//           status:
//             data.data[0].idea_submissions.status === 'submitted'
//               ? 'In Progress'
//               : 'Not Started',
//           description: data.data[0].idea_submissions.description,
//           projectScore: 85,
//           mentorFeedback: 'Feedback not available',
//           currentStage: 1,
//           stages: [
//             {
//               name: 'Idea Submission',
//               status: 'Completed',
//             },
//             {
//               name: 'Review',
//               status: 'In Progress',
//             },
//             {
//               name: 'Development',
//               status: 'Not Started',
//             },
//             {
//               name: 'Testing',
//               status: 'Not Started',
//             },
//             {
//               name: 'Deployment',
//               status: 'Not Started',
//             },
//           ],
//         };

//         setProjectData(transformedData);
//       } catch (err) {
//         setError(err.message || 'An unexpected error occurred.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjectData();
//   }, [userId]);

//   if (loading) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error: {error}
//         </Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ mt: 4, mb: 4, marginTop: '80px' }}>
//       {/* Profile Info Card */}
//       <Box mb={3}>
//         <Card elevation={3} sx={{ p: 4, textAlign: 'center', backgroundColor: '#f0f8ff', borderRadius: 3 }}>
//           <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: '#6a1b9a' }}>
//             👤 Profile Information
//           </Typography>
//           <Typography variant="body1" sx={{ fontSize: '1.2rem', mb: 1 }}>
//             Email: {userEmail || 'Not Available'}
//           </Typography>
//           <Typography variant="body1" sx={{ fontSize: '1.2rem' }}>
//             User ID: {userId}
//           </Typography>
//         </Card>
//       </Box>

//       <Grid container spacing={4}>
//         {/* Project Name and Description Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, backgroundColor: '#e8f5e9', borderRadius: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#1b5e20' }}>
//               🌐 Project Overview
//             </Typography>
//             <Typography variant="h6" sx={{ mb: 1, color: '#2e7d32' }}>
//               {projectData.projectName}
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.description}
//             </Typography>
//           </Card>
//         </Grid>

//         {/* Project Tracking Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, backgroundColor: '#f3e5f5', borderRadius: 3 }}>
//             <Typography
//               variant="h5"
//               gutterBottom
//               sx={{ color: '#4a148c', fontWeight: 'bold' }}
//             >
//               Project Tracking
//             </Typography>
//             <Stepper activeStep={projectData?.currentStage || 0} alternativeLabel>
//               {projectData?.stages?.map((stage, index) => (
//                 <Step key={stage.name}>
//                   <StepLabel
//                     StepIconComponent={() => {
//                       if (stage.status === 'Completed') return <CheckCircle color="success" />;
//                       if (stage.status === 'In Progress') return <HourglassEmpty color="warning" />;
//                       return <Cancel color="error" />;
//                     }}
//                   >
//                     {stage.name}
//                   </StepLabel>
//                 </Step>
//               ))}
//             </Stepper>
//           </Card>
//         </Grid>

//         {/* Project Score Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, textAlign: 'center', backgroundColor: '#e3f2fd', borderRadius: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#1565c0' }}>
//               ⭐ Project Score
//             </Typography>
//             <ScoreChip
//               icon={<Star fontSize="large" />}
//               label={`Overall Score: ${projectData.projectScore}/100`}
//             />
//           </Card>
//         </Grid>

//         {/* Mentor Feedback Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, backgroundColor: '#ffebee', borderRadius: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#b71c1c' }}>
//               🧠 Mentor Feedback
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.mentorFeedback}
//             </Typography>
//           </Card>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default StudentTrack;

// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Paper,
//   Typography,
//   CircularProgress,
//   Box,
//   Chip,
//   Divider,
//   Grid,
//   Card,
//   CardContent,
//   Stepper,
//   Step,
//   StepLabel,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { Star, CheckCircle, Cancel, HourglassEmpty } from '@mui/icons-material';

// const StatusChip = styled(Chip)(({ theme, status }) => ({
//   fontWeight: 'bold',
//   backgroundColor:
//     status === 'In Progress'
//       ? theme.palette.warning.main
//       : status === 'Completed'
//       ? theme.palette.success.main
//       : status === 'Not Started'
//       ? theme.palette.error.main
//       : theme.palette.info.main,
//   color: theme.palette.common.white,
// }));

// const ScoreChip = styled(Chip)(({ theme }) => ({
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
//   fontWeight: 'bold',
//   padding: theme.spacing(1),
//   fontSize: '1rem',
// }));

// const StudentTrack = () => {
//   const [projectData, setProjectData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const userEmail = localStorage.getItem('userEmail');
//   const userId = localStorage.getItem('user_id');

//   useEffect(() => {
//     const fetchProjectData = async () => {
//       try {
//         const response = await fetch(
//           `https://puneexpobackend.tdtlworld.com/api/project_info/?stud_id=${userId}`
//         );
//         if (!response.ok) {
//           throw new Error('Failed to fetch project data.');
//         }
//         const data = await response.json();

//         const transformedData = {
//           projectName: data.data[0].idea_submissions.title,
//           status:
//             data.data[0].idea_submissions.status === 'submitted'
//               ? 'In Progress'
//               : 'Not Started',
//           description: data.data[0].idea_submissions.description,
//           projectScore: 85,
//           mentorFeedback: 'Feedback not available',
//           currentStage: 1,
//           stages: [
//             {
//               name: 'Idea Submission',
//               status: 'Completed',
//             },
//             {
//               name: 'Review',
//               status: 'Completed',
//             },
//             {
//               name: ' Checked',
//               status: 'Completed',
//             },
//             {
//               name: 'Progress Status',
//               status: 'Not Started',
//             },
//             {
//               name: 'Investor Feedback',
//               status: 'Not Started',
//             },
//           ],
//         };

//         setProjectData(transformedData);
//       } catch (err) {
//         setError(err.message || 'An unexpected error occurred.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjectData();
//   }, [userId]);

//   if (loading) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
//         <CircularProgress />
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           Error: {error}
//         </Typography>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ mt: 4, mb: 4, marginTop: '80px' }}>
//       {/* Profile Info Card */}
//       <Box mb={3}>
//         <Card elevation={3} sx={{ p: 4, textAlign: 'center', backgroundColor: '#f0f8ff', borderRadius: 3 }}>
//           <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: '#6a1b9a' }}>
//             👤 Profile Information
//           </Typography>
//           <Typography variant="body1" sx={{ fontSize: '1.2rem', mb: 1 }}>
//             Project Leader Email: {userEmail || 'Not Available'}
//           </Typography>
//           {/* <Typography variant="body1" sx={{ fontSize: '1.2rem' }}>
//             User ID: {userId}
//           </Typography> */}
//         </Card>
//       </Box>

//       <Grid container spacing={4}>
//         {/* Project Name and Description Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, backgroundColor: '#e8f5e9', borderRadius: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#1b5e20' }}>
//               🌐 Project Overview
//             </Typography>
//             <Typography variant="h6" sx={{ mb: 1, color: '#2e7d32' }}>
//               {projectData.projectName}
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.description}
//             </Typography>
//           </Card>
//         </Grid>

//         {/* Project Tracking Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, backgroundColor: '#f3e5f5', borderRadius: 3 }}>
//             <Typography
//               variant="h5"
//               gutterBottom
//               sx={{ color: '#4a148c', fontWeight: 'bold' }}
//             >
//               Project Tracking
//             </Typography>
//             <Stepper activeStep={projectData?.currentStage || 0} alternativeLabel>
//               {projectData?.stages?.map((stage, index) => (
//                 <Step key={stage.name}>
//                   <StepLabel
//                     StepIconComponent={() => {
//                       if (stage.status === 'Completed') return <CheckCircle color="success" />;
//                       if (stage.status === 'In Progress') return <HourglassEmpty color="warning" />;
//                       return <Cancel color="error" />;
//                     }}
//                   >
//                     {stage.name}
//                   </StepLabel>
//                 </Step>
//               ))}
//             </Stepper>
//           </Card>
//         </Grid>

//         {/* Project Score Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, textAlign: 'center', backgroundColor: '#e3f2fd', borderRadius: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#1565c0' }}>
//               ⭐ Project Score
//             </Typography>
//             <ScoreChip
//               icon={<Star fontSize="large" />}
//               label={`Overall Score: ${projectData.projectScore}/100`}
//             />
//           </Card>
//         </Grid>

//         {/* Mentor Feedback Card */}
//         <Grid item xs={12} md={6}>
//           <Card elevation={3} sx={{ p: 4, backgroundColor: '#ffebee', borderRadius: 3 }}>
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#b71c1c' }}>
//               🧠 Mentor Feedback
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {projectData.mentorFeedback}
//             </Typography>
//           </Card>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default StudentTrack;
import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  CircularProgress,
  Box,
  Chip,
  Divider,
  Grid,
  Card,
  CardContent,
  Stepper,
  Step,
  StepLabel,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Star, CheckCircle, Cancel, HourglassEmpty, HourglassTop } from '@mui/icons-material';
import { Fade } from 'react-awesome-reveal';

const StatusChip = styled(Chip)(({ theme, status }) => ({
  fontWeight: 'bold',
  backgroundColor:
    status === 'In Progress'
      ? theme.palette.warning.main
      : status === 'Completed'
      ? theme.palette.success.main
      : status === 'Not Started'
      ? theme.palette.error.main
      : theme.palette.info.main,
  color: theme.palette.common.white,
}));

const ScoreChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontWeight: 'bold',
  padding: theme.spacing(1),
  fontSize: '1rem',
}));

const StudentTrack = () => {
  const [projectData, setProjectData] = useState(null);
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userEmail = localStorage.getItem('userEmail');
  const userId = localStorage.getItem('user_id');

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        const response = await fetch(
          `https://puneexpobackend.tdtlworld.com/api/project_info/?stud_id=${userId}`
        );
        if (!response.ok) {
          throw new Error('Failed to fetch project data.');
        }
        const data = await response.json();

        const transformedData = {
          projectName: data.idea_data.title,
          status:
            data.idea_data.status === 'submitted'
              ? 'In Progress'
              : 'Not Started',
          description: data.idea_data.description,
          projectScore: data.idea_data.ai_score || 85,
          mentorFeedback: 'Feedback not available',
          currentStage: 1,
          stages: [
            {
              name: 'Idea Submission',
              status: 'Completed',
            },
            {
              name: 'Review',
              status: 'Completed',
            },
            {
              name: 'Checked',
              status: 'Completed',
            },
            {
              name: 'Progress Status',
              status: 'Not Started',
            },
            {
              name: 'Investor Feedback',
              status: 'Not Started',
            },
          ],
        };

        setProjectData(transformedData);
        setStudentData(data.student_data);
      } catch (err) {
        setError(err.message || 'An unexpected error occurred.');
      } finally {
        setLoading(false);
      }
    };

    fetchProjectData();
  }, [userId]);

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ mt: 4, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography variant="h6" color="error" gutterBottom>
          Error: {error}
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4, marginTop: '80px' }}>
      {/* Profile Info Card */}
      <Box mb={3}>
        <Card elevation={3} sx={{ p: 4, textAlign: 'center', backgroundColor: '#f0f8ff', borderRadius: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: '#6a1b9a' }}>
            👤 Profile Information
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '1.2rem', mb: 1 }}>
             {studentData?.full_name || 'Not Available'}
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '1.2rem', mb: 1 }}>
            {studentData?.email || 'Not Available'}
          </Typography>
          {/* <Typography variant="body1" sx={{ fontSize: '1.2rem' }}>
            Institution: {studentData?.institution || 'Not Available'}
          </Typography> */}
        </Card>
      </Box>

      {/* Project Name and Description Card */}
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Card elevation={3} sx={{ p: 4, backgroundColor: '#e8f5e9', borderRadius: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#1b5e20' }}>
              🌐 Project Overview
            </Typography>
            <Typography variant="h6" sx={{ mb: 1, color: '#2e7d32' }}>
              {projectData.projectName}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {projectData.description}
            </Typography>
          </Card>
        </Grid>

        {/* Project Tracking Card */}
        <Grid item xs={12} md={6}>
          <Card elevation={3} sx={{ p: 4, backgroundColor: '#f3e5f5', borderRadius: 3 }}>
            <Typography variant="h5" gutterBottom sx={{ color: '#4a148c', fontWeight: 'bold' }}>
              Project Tracking
            </Typography>
            <Stepper activeStep={projectData?.currentStage || 0} alternativeLabel>
              {projectData?.stages?.map((stage, index) => (
                <Step key={stage.name}>
                  <StepLabel
                    StepIconComponent={() => {
                      if (stage.status === 'Completed') return <CheckCircle color="success" />;
                      if (stage.status === 'In Progress') return <HourglassEmpty color="warning" />;
                      return <Cancel color="error" />;
                    }}
                  >
                    {stage.name}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Card>
        </Grid>

        {/* Project Score Card */}
        <Grid item xs={12} md={4}>
  <Card 
    elevation={3} 
    sx={{ 
      p: 4, 
      textAlign: 'center', 
      backgroundColor: '#e3f2fd', 
      borderRadius: 3, 
      height: '100%', // Ensures all cards have the same height
      display: 'flex', // Allows you to use flexbox for vertical alignment
      flexDirection: 'column', // Aligns the content vertically
      justifyContent: 'space-between' // Distributes the content evenly inside the card
    }}
  >
    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#1565c0' }}>
      ⭐ Project Score
    </Typography>
    {/* <ScoreChip icon={<Star fontSize="large" />} label={`Overall Score: ${projectData.projectScore}/100`} /> */}
  </Card>
</Grid>
{/* Admin Approval Status */}
<Grid item xs={12} md={4}>
  <Card 
    elevation={3} 
    sx={{ 
      p: 4, 
      textAlign: 'center', 
      backgroundColor: '#fff9c4', 
      borderRadius: 3, 
      height: '100%', // Ensures all cards have the same height
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'space-between'
    }}
  >
    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#ff6f00' }}>
      📋  Approval Status
    </Typography>
    <Typography variant="body1" sx={{ fontSize: '1.2rem', mb: 2 }}>
      {projectData.status === 'In Progress' ? (
        <>
          <HourglassTop sx={{ fontSize: 30, color: '#ff6f00' }} />
          <Fade duration={2000}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#ff6f00' }}>
              Wait for Shortlisting
            </Typography>
          </Fade>
        </>
      ) : (
        <>
          <CheckCircle sx={{ fontSize: 30, color: 'green' }} />
          <Fade duration={2000}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'green' }}>
              Idea is Shortlisted
            </Typography>
          </Fade>
        </>
      )}
    </Typography>
  </Card>
</Grid>
{/* Mentor Feedback Card */}
<Grid item xs={12} md={4}>
  <Card 
    elevation={3} 
    sx={{ 
      p: 4, 
      backgroundColor: '#ffebee', 
      borderRadius: 3, 
      height: '100%', // Ensures all cards have the same height
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'space-between'
    }}
  >
    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#b71c1c' }}>
      🧠 Mentor Feedback
    </Typography>
    <Typography variant="body1" color="text.secondary">
      {projectData.mentorFeedback}
    </Typography>
  </Card>
</Grid>



        
      </Grid>
    </Container>
  );
};

export default StudentTrack;
